import commonJsModule from "jsdoc-tsd-webpack-plugin"

export default commonJsModule.default